import React, { useState, useEffect, useCallback } from "react";
import { useObjectStore } from "../zustand/objects";
import { Box } from "@mui/material/";
import { Switch, ActionIcon, Menu, Text } from '@mantine/core';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import PanToolIcon from '@mui/icons-material/PanTool';

const CommentCursor = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        
        const updateMousePosition = (e) => {
            setPosition({ x: e.clientX, y: e.clientY });
        };

        window.addEventListener("mousemove", updateMousePosition);

        return () => {
            window.removeEventListener("mousemove", updateMousePosition);
        };
    }, []);

   
    return (
        <div style={{ cursor: "none" }}> {/* Hides the default cursor */}
            <div
                style={{
                    position: "fixed",
                    top: position.y,
                    left: position.x,
                    pointerEvents: "none", // Ensures it doesn't interfere with clicks
                    transform: "translate(-50%, -50%)",
                    fontSize: "24px"
                }}>💬
                {/* <CommentOutlinedIcon style={{ fontSize: "24px", color: "black" }} /> */}

            </div>
        </div>
    );
}


export const AddCommentButton = () => {
    const {
        currentObjectArtboard,
        updateArtboard,
        artboards,
        storyboardFields,
        commentClickStatus,
        handleCommentButtonClick,
        addThread,
        setShowingComments,
        showingComments
    } = useObjectStore();

    const artboardsAmount = artboards && Object.keys(artboards).length

    const [hover1, setHover1] = useState(false)
    const [clicked, setClicked] = useState(false)

    const handleClick = () => {
        setClicked(!clicked)
        handleCommentButtonClick('add')
        // handleCommentButtonClick(!commentClickStatus.clicking)
    } 

    const handleLocationClick = useCallback((intersectionPoint) => {
        addThread(intersectionPoint);
        setClicked(!clicked);
    }, [addThread, clicked]);

    
    return (<>
    {commentClickStatus.clicking && <CommentCursor type={'add'}/>}
                <Menu trigger="click-hover" closeOnItemClick={false}>
                    <Menu.Target>
            <ActionIcon variant="transparent" 
                onPointerOver={() => setHover1(true)}
                onPointerLeave={() => setHover1(false)}
                color={!hover1 ? "#424242" : "#868e96"}>
                <Text size="lg">
                💬</Text>
                </ActionIcon>
                </Menu.Target>

        <Menu.Dropdown>
            <Menu.Item onClick={handleClick}>
                Add comment
            </Menu.Item>
            <Menu.Item>
                <Switch checked={showingComments} label="Show comments" color="gray" 
                onChange={() => setShowingComments(!showingComments)}/>
                </Menu.Item>
        </Menu.Dropdown>
                </Menu>
        
        </>
    );
};




export const MoveCommentButton = ({threadsId, artboard, position}) => {
    const {
        currentObjectArtboard,
        updateArtboard,
        updateThread,
        artboards,
        storyboardFields,
        commentClickStatus,
        handleCommentButtonClick
    } = useObjectStore();

    const artboardsAmount = artboards && Object.keys(artboards).length

    const [hover1, setHover1] = useState(false)
    const [clicked, setClicked] = useState(false)

    const handleClick = () => {
        setClicked(!clicked)
        handleCommentButtonClick('move', threadsId, artboard, position)
        // handleCommentButtonClick(!commentClickStatus.clicking)
    } 

    // to update single thread position we need to 
    // 1. get all id, position, artboard, projectKey for thread – replace position with new position
    // 2. send to realtime channel via realtime message
    // 3. in xano updateFunction trigger threadUpdate and change position
    // 4. message hits whole of channel (including client)
    // 5. all channel members loadThreads to show new position
    // 5b. how will this impact those with 'open' threads?

    // to update bulk threads off the back of an artboard change
    // 1. in xano artboard add/delete func, look for an update artboard of relevant threads
    // 1b. delete any threads in project, also delete comments that are ON that specific artboard
    // 1c. then minus one from artboard number of any threads in project with artboards larger than deleted artboard
    // 2. this means that if we have an artboard added or deleted, we need to trigger 'loadThreads' in channel members
    // 2b. might be able to only trigger this is we have needed to make thread updates, maybe make this conditional


    return (<>
    {/* {commentClickStatus.clicking && <CommentCursor clickFunction={handleClick} type={'move'} threadsId={threadsId} artboard={artboard} position={position} />} */}
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                height: "100%",
            }}>
            <ActionIcon ml={5} w={30} variant="transparent" size={'xs'}
                onPointerOver={() => setHover1(true)}
                onPointerLeave={() => setHover1(false)}
                color={!hover1 ? "#424242" : "#868e96"} 
                onClick={handleClick}>
                <PanToolIcon fontSize='small' /></ActionIcon>
        </Box></>
    );
};




